import { Link, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function PaymentCancel() {
  const [search] = useSearchParams();
  const bookingId = search.get("booking_id");
  return (
    <div className="min-h-screen bg-[#0b0f17]">
      <Navbar />
      <section className="mx-auto max-w-2xl px-4 sm:px-6 lg:px-8 py-20 text-center" data-testid="payment-cancel-section">
        <div className="cj-card p-10">
          <XCircle className="h-14 w-14 text-slate-400 mx-auto" />
          <h1 className="font-display mt-6 text-3xl sm:text-4xl font-extrabold uppercase text-slate-100">
            Deposit not completed
          </h1>
          <p className="mt-3 text-slate-400">
            No worries — your booking is still saved and waiting. Resume the deposit any time.
          </p>
          <div className="mt-8 flex items-center justify-center gap-3">
            <Link
              to="/book"
              data-testid="payment-cancel-retry-button"
              className="cj-btn-primary px-6 py-3 rounded-full"
            >
              Try again
            </Link>
            <Link to="/" className="cj-btn-ghost px-6 py-3 rounded-full">
              Home
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
